/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function BuildingFromJSON(json) {
    return BuildingFromJSONTyped(json, false);
}
export function BuildingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'buildingId': !exists(json, 'buildingId') ? undefined : json['buildingId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'campus': !exists(json, 'campus') ? undefined : json['campus'],
        'buildingCode': !exists(json, 'buildingCode') ? undefined : json['buildingCode'],
        'buildingName': !exists(json, 'buildingName') ? undefined : json['buildingName'],
        'buildingNameAlt': !exists(json, 'buildingNameAlt') ? undefined : json['buildingNameAlt'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'contactName': !exists(json, 'contactName') ? undefined : json['contactName'],
        'accountCode1': !exists(json, 'accountCode1') ? undefined : json['accountCode1'],
        'accountCode2': !exists(json, 'accountCode2') ? undefined : json['accountCode2'],
        'accountCode3': !exists(json, 'accountCode3') ? undefined : json['accountCode3'],
        'jobTypes': !exists(json, 'jobTypes') ? undefined : json['jobTypes'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'buildingPhotoData': !exists(json, 'buildingPhotoData') ? undefined : json['buildingPhotoData'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
    };
}
export function BuildingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'buildingId': value.buildingId,
        'propertyId': value.propertyId,
        'campus': value.campus,
        'buildingCode': value.buildingCode,
        'buildingName': value.buildingName,
        'buildingNameAlt': value.buildingNameAlt,
        'category': value.category,
        'address': value.address,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'country': value.country,
        'contactName': value.contactName,
        'accountCode1': value.accountCode1,
        'accountCode2': value.accountCode2,
        'accountCode3': value.accountCode3,
        'jobTypes': value.jobTypes,
        'notes': value.notes,
        'buildingPhotoData': value.buildingPhotoData,
        'detail': value.detail,
    };
}
